import React from 'react'
import drivingLicenceImg from '../assets/images/ListIcons/DrivingLicence.png';
import nationalIdImg from '../assets/images/ListIcons/NationalID.png';
import passportImg from '../assets/images/ListIcons/Passport.png';
import residencePermitImg from '../assets/images/ListIcons/ResidencePermit.png';
import RightArrow from '../assets/images/svg/RightArrow';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { applicationStore } from '../store/ApplicationStore';
import { IdentificationTypes } from 'src/enums/IdentificationTypes';
import { COUNTRIES_WITH_CUSTOM_MODEL, DEFAULT_MODEL_CONTROL_NAME } from 'src/constants/countryConfig';
import { useTranslation } from 'react-i18next';
import { getVerificationDocHeaderKey } from 'src/constants/verificationDocs';

const VerificationList = observer(({ ...props }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const { data } = props;
    const handleSelect = (docType, modelCotrolName, front, back) => {
        applicationStore.setVerificationSteps({ ...applicationStore.verificationSteps, activeStep: docType });
        applicationStore.setDocumentSurface({ front: !front, back: !back })
        applicationStore.setDocsType(docType);
        const countryHasCustomModel = COUNTRIES_WITH_CUSTOM_MODEL.includes(applicationStore.country);
        applicationStore.setModelCotrolName(countryHasCustomModel ? modelCotrolName : DEFAULT_MODEL_CONTROL_NAME);
        navigate('/verification', { replace: true, state: { id: docType, headerKey: getVerificationDocHeaderKey(docType) } });
    }
    return (
        <div className='grid gap-2'>
            {data?.hasResidencePermit ? (
                <div className={`flex justify-between items-center py-3 px-4 rounded-[16px] hover:bg-Carrara100 cursor-pointer bg-Carrara50`}
                    onClick={() => handleSelect(IdentificationTypes.RESIDENCE_PERMIT, IdentificationTypes.RESIDENCE_PERMIT, true, true)}>
                    <div className="inline-flex items-center space-x-2">
                        <div className='w-[40px] h-[40px] '>
                            <figure><img className='border-Submarine300 border-[1px] rounded-[12px]' src={residencePermitImg} alt={t('verificationList.residencePermit')} /></figure>
                        </div>
                        <div className="text-Gray950">{t('verificationList.residencePermit')}</div>
                    </div>
                    <div>
                        <RightArrow />
                    </div>
                </div>) : null}
            {data?.hasIdCard ? (
                <div className={`flex justify-between items-center py-3 px-4 rounded-[16px] hover:bg-Carrara100 cursor-pointer bg-Carrara50`}
                    onClick={() => handleSelect(IdentificationTypes.IDENTITY_CARD, 'id', true, true)}>
                    <div className="inline-flex items-center space-x-2">
                        <div className='w-[40px] h-[40px] '>
                            <figure><img className='border-Submarine300 border-[1px] rounded-[12px]' src={nationalIdImg} alt={t('verificationList.nationalId')} /></figure>
                        </div>
                        <div className="text-Gray950">{t('verificationList.nationalId')}</div>
                    </div>
                    <div>
                        <RightArrow />
                    </div>
                </div>
            ) : null}
            {data?.hasPassport ? (
                <div className={`flex justify-between items-center py-3 px-4 rounded-[16px] hover:bg-Carrara100 cursor-pointer bg-Carrara50`}
                    onClick={() => handleSelect(IdentificationTypes.PASSPORT, IdentificationTypes.PASSPORT, true, false)}>
                    <div className="inline-flex items-center space-x-2">
                        <div className='w-[40px] h-[40px] '>
                            <figure><img className='border-Submarine300 border-[1px] rounded-[12px]' src={passportImg} alt={t('verificationList.passport')} /></figure>
                        </div>
                        <div className="text-Gray950">{t('verificationList.passport')}</div>
                    </div>
                    <div>
                        <RightArrow />
                    </div>
                </div>
            ) : null}
            {data?.hasDriverLicence ? (
                <div className={`flex justify-between items-center py-3 px-4 rounded-[16px] hover:bg-Carrara100 cursor-pointer bg-Carrara50`}
                    onClick={() => handleSelect(IdentificationTypes.DRIVER_LICENSE, IdentificationTypes.DRIVER_LICENSE, true, true)}>
                    <div className="inline-flex items-center space-x-2">
                        <div className='w-[40px] h-[40px] '>
                            <figure><img className='border-Submarine300 border-[1px] rounded-[12px]' src={drivingLicenceImg} alt={t('verificationList.drivingLicense')} /></figure>
                        </div>
                        <div className="text-Gray950">{t('verificationList.drivingLicense')}</div>
                    </div>
                    <div>
                        <RightArrow />
                    </div>
                </div>
            ) : null}

        </div>
    )
})

export default VerificationList
